import { css } from "styled-components";

const InputHourListHours = css`
  li {
    color: #657480;
    font-weight: 500;
    &:hover {
      color: #657480;
      background-color: #BBEDF8;
    }
  }
`;


export default InputHourListHours;
